import { Link } from 'react-router-dom';
import styles from './MarketingLayout.module.css';

const DEFAULT_FOOTER_LINKS = [
  { href: 'https://docs.vennio.app', label: 'Docs', external: true },
  { to: '/pricing', label: 'Pricing' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { href: 'mailto:matt@vennio.app', label: 'Contact', external: true },
];

export default function MarketingLayout({ children, footerLinks = DEFAULT_FOOTER_LINKS }) {
  return (
    <div className={styles.page}>

      {/* ── Nav ── */}
      <header className={styles.nav}>
        <div className={styles.navInner}>
          <Link to="/" className={styles.navBrand}>Vennio</Link>
          <nav className={styles.navLinks}>
            <Link to="/pricing" className={styles.navLink}>Pricing</Link>
            <Link to="/auth" className="btn">Sign In</Link>
          </nav>
        </div>
      </header>

      <main>{children}</main>

      {/* ── Footer ── */}
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerLeft}>
            <span className={styles.footerBrand}>Vennio</span>
            <span className={styles.footerTagline}>Infrastructure for Time</span>
          </div>
          <nav className={styles.footerLinks}>
            {footerLinks.map(({ href, to, label, external }) =>
              external ? (
                <a key={label} href={href} className={styles.footerLink} target="_blank" rel="noopener noreferrer">{label}</a>
              ) : (
                <Link key={label} to={to} className={styles.footerLink}>{label}</Link>
              )
            )}
          </nav>
        </div>
      </footer>

    </div>
  );
}
